/* Generado desde SelectionToolbar.razor.css del portal actual (scripts/razor-css-to-module.py): misma cascada que Blazor. */
.bh-table-toolbar.scope{display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:44px;margin:8px 0;color:inherit;font-size:14px}
.bh-selection-toolbar.scope{border-radius:12px;padding:0 8px;background:var(--primary-soft);color:var(--text)}
